<template>
  <div class="bggray">
    <div class="con100">
      <app-header />
      <div class="orderWrap">
        <div class="orderNav">
          <span class="cur">确认购买信息</span>
          <span class="cur">选择支付方式</span>
          <span class="cur">购买成功开通权限</span>
        </div>
        <div class="mod orderInfo orderDetail">
          <h3 class="title">订单详情</h3>
          <ul class="column5">
            <li>
              <div>产品名称</div>
              <div>订单编号</div>
              <div>数量</div>
              <div>实付款（元）</div>
              <div>支付方式</div>
            </li>
            <li v-if="orderInfo.productPriceVo">
              <div>{{orderInfo.productPriceVo.productName}}</div>
              <div>{{orderInfo.id}}</div>
              <div v-if="orderInfo.dateUnit === 'day'">{{orderInfo.productPriceVo.month}}天</div>
              <div v-else>{{orderInfo.productPriceVo.month}}个月</div>
              <div>¥ {{orderInfo.productPriceVo.curPrice}}</div>
              <div v-if="orderInfo.payMode == 0">未支付</div>
              <div v-else-if="orderInfo.payMode == 3">线下支付</div>
              <div v-else-if="orderInfo.payMode == 4">点卡</div>
              <div v-else-if="orderInfo.payMode == 7">快钱</div>
              <div v-else-if="orderInfo.payMode == 11 || orderInfo.payMode == 29">支付宝</div>
              <div v-else-if="orderInfo.payMode == 23">微信</div>
              <div v-else-if="orderInfo.payMode == 25 || orderInfo.payMode == 26 || orderInfo.payMode == 27">银联</div>
              <div v-else-if="orderInfo.payMode == 35">大额充值</div>
              <div v-else-if="orderInfo.payMode == 36">暂存开通</div>
              <div v-else-if="orderInfo.payMode == 38">折期支付</div>
              <div v-else-if="orderInfo.payMode == 42">微信</div>
              <div v-else>其他</div>
            </li>
            <li v-show="subProductPriceVos.length > 0" v-for="item in subProductPriceVos" :key="item.productName">
              <div>{{item.productName}}</div>
              <div>{{orderInfo.id}}</div>
              <div v-if="orderInfo.dateUnit === 'day'">*{{item.month}}天</div>
              <div v-else>*{{item.month}}个月</div>
              <div>¥ {{item.curPrice}}</div>
            </li>
          </ul>
          <div class="subtotal">
            <div>小计</div>
            <div>共{{productNum}}件</div>
            <div>¥ {{orderInfo.payMoney}}</div>
          </div>
          <div class="orderTime">下单时间：{{orderInfo.orderTime | dateFormat("yyyy-MM-dd")}}</div>
        </div>
        <div class="mod pl">
          <h3 class="title">用户信息</h3>
          <ul class="dispatch-list">
            <li>账号：{{userName}}</li>
            <li>
              发票：电子发票
              <span v-if="orderInfo.invoiceTitleType == 1">个人</span>
              <span v-if="orderInfo.invoiceTitleType == 2">单位</span>
            </li>
          </ul>
          <div class="btn-list">
            <span class="btn-normal" @click="downloadProtocol">下载电子协议</span>
            <span class="btn-normal" @click="download">下载软件</span>
            <router-link :to="'/'" class="btn-normal">完成</router-link>
          </div>
        </div>
        <!-- <p class="tips">
        尊敬的客户您好！<br>
        我们将使用您当前账号绑定的手机号{{tel}}开通企业预警通，预计需要1个工作日，开通后您可在企业预警通APP上同步登陆。如有疑问，可拨打021-20219997咨询。</p> -->
      </div>

    </div>
    <div class="con100-footer">
      <app-footer />
    </div>
  </div>
</template>

<script>
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";

export default {
  components: {
    AppHeader,
    AppFooter
  },
  data() {
    return {
      id: this.$route.params.id,
      userName: this.$storage.getUserName(),
      orderInfo: {},
      subProductPriceVos: [],
      productNum: 1,
      tel:""
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$get("/order/detail?id=" + this.id)
        .then(response => {
          if (response.code === 0) {
            this.orderInfo = response.data;
            if(response.data.productPriceVo.subProductPriceVos) {
              this.subProductPriceVos = response.data.productPriceVo.subProductPriceVos
              this.productNum = response.data.productPriceVo.subProductPriceVos.length + 1
            }
            this.$get('user/checkMobile').then(res =>{
              if(res.code === 0) {
                this.tel = res.data
              }
            }).catch(err => {
              this.$global.alertError();
            });
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    download() {
      this.$get("/product/query?id=" + this.orderInfo.productId).then(
        response => {
          if (response.code === 0 && response.data.downloadUrl != 0) {
            window.location.href = response.data.downloadUrl;
          } else {
            window.open("http://www.gw.com.cn/download.shtml");
          }
        }
      );
    },
    downloadProtocol () {
      this.$get("/protocol/checkDown?id=" + this.id).then(
        response => {
          if (response.code === 0 ) {
            let url = window.g.baseUrl + '/protocol/down?id=' + this.id
            window.location.href = url
          } else {
           this.$global.alert(response.msg);
          }
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/scss/order.scss";
.btn-list {
  a, span {
    bottom: 40px;
    cursor: pointer;
    &:first-child {
      right: 480px;
    }
    &:nth-child(2) {
      right: 290px;
    }
  }
}
.dispatch-list {
  padding-bottom: 40px;
}
.btn-normal {
  &:hover{
    background: #1460db;
  }
}
.orderTime{
  text-align: right;
  color: #222222;
  margin-top: 20px;
}
.orderDetail{
  ul {
    li{
      overflow: hidden;
      border-bottom: 0;
      color: #333333;
      &:nth-child(1) {
        border-bottom: 1px solid #e3e3e3;
      }
      &:nth-child(2) {
        font-weight: bold;
        margin-bottom: 10px;
      }
    }
  }
  .subtotal{
    div{
      &:nth-child(1){
        width: 445px;
      }
      &:nth-child(2){
        width: 140px;
      }
      &:nth-child(3){
        color: #EF3939;
      }
    }
  }
}
.tips{
  padding: 0 60px 30px;
  font-size: 18px;
  line-height: 26px;
  color: #666;
}
</style>


// WEBPACK FOOTER //
// src/pages/order/OrderDetail.vue